import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useCallback,
} from "react";
import Select from "./Select";
import FuncionesContext from "../context/FuncionesContext";
import Obligatorio from "../ABM/componentes/inputs/ObligatorioA";
import { useRefDataStore } from "../../..";
import { getAtributo, getCurrentQueryParams } from "../context/FuncionesContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

import axios from "axios";
import { farmageo_api } from "../../../config";

const Select_Enlazable = (props) => {
  const {
    data,
    cab,
    hijos,
    campokey,
    context,
    id_elemento,
  } = props;

  const nombre = getAtributo("nombre", data, cab);
  const select_info_adicional =
    getAtributo("select_info_adicional", data, cab) === "s";
  const select_info_adicional_campo = getAtributo(
    "select_info_adicional_campo",
    data,
    cab,
  );

  const disabledAtributo = getAtributo("disabled", data, cab);
  const disabled =
    disabledAtributo === true ||
    disabledAtributo === "true" ||
    disabledAtributo === "s";
  const select_esclavo_limpiar_onChange =
    getAtributo("select_esclavo_limpiar_onChange", data, cab) === "s";

  const { permite_null } = cab;

  // NUEVO: detectar icono_obligatorio (desde data o cab)
  const icono_obligatorio = getAtributo("icono_obligatorio", data, cab) === "s";

  const { superSubmit, renderEnModal } = useContext(FuncionesContext);

  const { setFiltro, filtros } = useContext(context);

  const valueStoreKey = data._key + campokey;
  const labelStoreKey = data._key + campokey + "_label";
  const updateIdStoreKey = data._key + cab.update_id_alias;

  const [storedValue, setStore] = useRefDataStore((s) => s[valueStoreKey]);
  const [storedUpdateId] = useRefDataStore((s) => s[updateIdStoreKey]);
  const [store] = useRefDataStore((s) => s);

  const currentExternalValue =
    filtros[cab.id_a] ?? storedValue ?? data[campokey] ?? undefined;

  const [opciones, setOpciones] = useState(componerOpciones());
  const [value, setValue] = useState(currentExternalValue);
  const [opElegida, setOpElegida] = useState(() => {
    return opciones.find((op) => op.value == currentExternalValue);
  });

  const [lastValue, setLastvalue] = useState(currentExternalValue);

  const loadingOpt = useRef(false);

  const esclavo_requiere_maestro =
    getAtributo("select_esclavo_requiere_maestro", data, cab) ?? "s";

  const acepta_maestro_parcial =
    getAtributo("select_maestro_parcial", data, cab) ?? "n";

  const handleCancelar = useCallback(() => {
    const rollbackValue = storedValue ?? data[campokey];
    setValue(rollbackValue);
    setLastvalue(rollbackValue);
  }, [campokey, data, storedValue]);

  const handleChange = useCallback(
    async (e) => {
      const valorRecibido = e.target.value;
      const update_id = storedUpdateId ?? data[cab.update_id_alias];

      if (
        valorRecibido === null ||
        lastValue?.toString() === valorRecibido.toString().trim()
      ) {
        return;
      }

      const { id_a } = cab;

      const opcionSeleccionada = opciones.find(
        (op) => String(op.value) === String(valorRecibido),
      );

      if (!opcionSeleccionada) {
        console.error("Valor fuera de las opciones actuales", {
          valorRecibido,
          opciones,
          opcionesCab: cab.opciones,
        });
        return;
      }

      const valor = opcionSeleccionada.value;

      setValue(valor);

      if (cab.select_es_maestro === "s") {
        setFiltro({ id_a, valor });

        document.dispatchEvent(
          new CustomEvent(`${cab.id_a}_cambio`, {
            detail: {
              value: valor,
              opcion: opcionSeleccionada,
              id_a: cab.id_a,
              cab,
            },
          }),
        );
      }

      if (cab.select_no_guarda === "s") {
        setLastvalue(valor);
        const targetKey =
          cab.clave_envio && cab.clave_envio.trim() !== ""
            ? cab.clave_envio
            : campokey;

        data[targetKey] = valor;

        // Estas keys se guardan en `data` para que otros campos (via
        // insert_ids/clave_envio) puedan leerlas con getAtributo, pero deben
        // quedar afuera del key={JSON.stringify(dato)} de Tarjeta.js para no
        // forzar un remount de la fila que corta el fetch de selects
        // dependientes en curso.
        if (!Object.prototype.hasOwnProperty.call(data, "__volatileKeys__")) {
          Object.defineProperty(data, "__volatileKeys__", {
            value: new Set(),
            enumerable: false,
            configurable: true,
            writable: false,
          });
        }
        data.__volatileKeys__.add(targetKey);
        return;
      }

      const cabParaSubmit = {
        ...cab,
        opciones,
      };

      const result = await superSubmit({
        valor,
        id_a,
        update_id,
        handleCancelar,
        cab: cabParaSubmit,
        data,
      });

      setLastvalue(valor);
      setStore({ [valueStoreKey]: valor });

      if (!update_id && result?.data?.registro?.id) {
        setStore({
          [updateIdStoreKey]: result.data.registro.id,
        });
      }

      setOpElegida(opcionSeleccionada);

      setStore({
        [labelStoreKey]: opcionSeleccionada.label,
      });
    },
    [
      cab,
      data,
      handleCancelar,
      lastValue,
      opciones,
      setFiltro,
      setStore,
      storedUpdateId,
      superSubmit,
      updateIdStoreKey,
      valueStoreKey,
      labelStoreKey,
    ],
  );

  function componerOpciones() {
    const value_null =
      data[cab.id_a + "_select_value_null"] ?? cab.select_value_null;
    const label_null =
      data[cab.id_a + "_select_label_null"] ?? cab.select_label_null;
    const opcion_null = {
      value: value_null ? value_null : null,
      label: label_null ? label_null : "Ninguno",
      disabled,
    };
    if (Array.isArray(cab.opciones)) return cab.opciones;
    if (data[cab.id_a + "_opciones"]) {
      const opciones_de_query_general = JSON.parse(
        data[cab.id_a + "_opciones"],
      );

      if (Array.isArray(opciones_de_query_general)) {
        if (value_null || label_null)
          opciones_de_query_general.push(opcion_null);
        return opciones_de_query_general;
      }
    }
    if (value_null || label_null) {
      return [opcion_null];
    }
    return [];
  }

  useEffect(() => {
    //setea informacion para recuperarla como dataView
    setStore({
      [labelStoreKey]: opciones
        .filter((op) => op.value?.toString() === value?.toString())
        .pop()?.label,
    });
  }, [labelStoreKey, opciones, setStore, value]);

  const firstRender = useRef(0);

  useEffect(() => {
    if (!cab.select_depende_de) return;

    const maestros = cab.select_depende_de
      .split(",")
      .map((m) => m.trim())
      .filter(Boolean);

    if (maestros.length === 0) return;

    const handler = ({ detail }) => {
      const valorMaestro = maestros
        .map((m) => (m === detail.id_a ? detail.value : store[data._key + m]))
        .filter((c) => c);

      if (loadingOpt.current) return;
      loadingOpt.current = true;

      if (
        (esclavo_requiere_maestro === "s" &&
          valorMaestro.length < maestros.length) ||
        (acepta_maestro_parcial === "n" &&
          valorMaestro.length < maestros.length &&
          valorMaestro.length > 0)
      ) {
        loadingOpt.current = false;
        return;
      }

      const queryStringsObject = getCurrentQueryParams()
      console.log(queryStringsObject)

      axios
        .post(farmageo_api + "/select/opciones", {
          [cab.id_a]: valorMaestro, ...queryStringsObject
        })
        .then((res) => {
          setOpciones(res.data);

          const currentValue = store[valueStoreKey] ?? data[campokey];
          if (currentValue !== undefined && currentValue !== null) {
            const opElegida = res.data.find(
              (op) => op.value == currentValue,
            );

            if (opElegida) {
              setOpElegida(opElegida);
            } else if (select_esclavo_limpiar_onChange) {
              handleChange({ target: { value: "null" } });
            }
          }
        })
        .finally(() => {
          loadingOpt.current = false;
        });
    };

    maestros.forEach((m) => {
      document.addEventListener(`${m}_cambio`, handler);
    });

    if (firstRender.current === 0) {
      handler({ detail: {} });
      firstRender.current += 1;
    }

    return () => {
      maestros.forEach((m) => {
        document.removeEventListener(`${m}_cambio`, handler);
      });
    };
  }, [
    acepta_maestro_parcial,
    cab.id_a,
    cab.select_depende_de,
    campokey,
    data,
    esclavo_requiere_maestro,
    handleChange,
    select_esclavo_limpiar_onChange,
    store,
    valueStoreKey,
  ]);

  useEffect(() => {
    setValue(currentExternalValue);
    setLastvalue(currentExternalValue);
  }, [currentExternalValue]);

  return (
    //<div style={{ textAlign: "center"}}>
    <div
      id={id_elemento}
      style={{
        display: "flex",
        flex: "1 0 100%",
        justifyContent: "space-between",
      }}
    >
      <div
        className="vista_label_select"
        style={select_info_adicional ? { display: "flex", width: "95%" } : {}}
      >
        {cab.nombre ? (
          <p
            style={{
              flexShrink: 0,
              flexWrap: "wrap",
              color: disabled ? "#777" : undefined,
            }}
          >
            {cab.nombre}:
          </p>
        ) : (
          <></>
        )}
        {/* Contenedor: select + icono obligatorio + 'x' hijos */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            width: cab.width_input,
            position: "relative",
          }}
        >
          <Select
            id={cab.id_a}
            nombre={nombre}
            opciones={opciones}
            value={value}
            onChange={handleChange}
            def={cab.default}
            disabled={loadingOpt.current || disabled}
            className={data[cab.id_a + "_className"] ?? cab.className}
            permite_null={permite_null}
            loading={loadingOpt.current}
          />
          {/* Estrella por icono_obligatorio (a la derecha del select) */}
          {icono_obligatorio && <span className="icono_obligatorio">*</span>}
          {/* Estrella/indicador por permite_null (comportamiento existente) */}
          <Obligatorio permite_null={cab.permite_null} />
          {hijos}
        </div>
      </div>
      {select_info_adicional && opElegida && select_info_adicional_campo ? (
        <div
          style={{ cursor: "pointer", fontSize: "1rem", marginLeft: "1rem" }}
          onClick={() =>
            renderEnModal(opElegida[select_info_adicional_campo], {
              modal: "modal-viewportWidth80",
            })
          }
        >
          <FontAwesomeIcon icon={faInfoCircle} />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Select_Enlazable;
